import { BaseDialogBox, InsurancePhoneNumber, PhoneButton } from "raci-react-library";

export interface DuplicatePolicyDialogProps {
  show: boolean;
  onClose: () => void;
}

export const DuplicatePolicyDialog: React.FC<DuplicatePolicyDialogProps> = ({ show, onClose }) => {
  return (
    <BaseDialogBox
      showDialog={show ?? false}
      setShowDialog={function (open: boolean): void {
        onClose && onClose();
      }}
      title={"You may already be insured"}
      buttons={[
        <PhoneButton
          phone={InsurancePhoneNumber}
          key={InsurancePhoneNumber.displayWithoutSpaces}
          id={"InsurancePhoneNumberButtonId"}
          isPrimary={true}
          fullWidth
          style={{ height: "48px" }}
        />,
      ]}
      content={"Please call us so we can help you."}
    ></BaseDialogBox>
  );
};

export default DuplicatePolicyDialog;
